<template>
  <div class="order-prolongation-skeleton-wrapper">
    <div v-if="isLoading" class="order-prolongation-skeleton-list">
      <div class="skeleton-order-header">
        <div class="skeleton-order-content">
          <div class="skeleton-line">
            <div class="skeleton-block"></div>
          </div>
          <div class="skeleton-line secondary">
            <div class="skeleton-block"></div>
          </div>
        </div>
        <div class="skeleton-order-header-meta">
          <div class="skeleton-line">
            <div class="skeleton-block"></div>
          </div>
        </div>
      </div>
      <div
        v-for="i in 5"
        :key="i"
        class="skeleton-order-item"
      >
        <div class="skeleton-order-content">
          <div class="skeleton-line primary">
            <div class="skeleton-block"></div>
          </div>
          <div class="skeleton-line secondary">
            <div class="skeleton-block"></div>
          </div>
        </div>
        <div class="skeleton-order-meta">
          <div class="skeleton-line meta-line">
            <div class="skeleton-block"></div>
          </div>
        </div>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.order-prolongation-skeleton-wrapper {
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.order-prolongation-skeleton-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.skeleton-order-header, .skeleton-order-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px;
}

.skeleton-order-header {
  align-items: center;

  .skeleton-block {
    width: 45%;
    height: 24px;
  }

  &-meta {
    .skeleton-block {
      width: 30px;
      height: 24px;
    }
  }
}

.skeleton-order-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-order-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;

  .skeleton-block {
    width: 100px;
    height: 20px;
  }
}

.skeleton-line {
  display: flex;

  &.primary {
    .skeleton-block {
      width: 35%;
      height: 20px;
    }
  }

  &.secondary {
    .skeleton-block {
      width: 30%;
      height: 20px;
    }
  }
}

.skeleton-block {
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.4s infinite;
  height: 20px;
  margin-right: 5px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
